export interface Tier {
  cap: number;
  price: number;
}

const convertToTiers = (borders: number[], prices: number[]): Tier[] => {
  if (!Array.isArray(borders) || !Array.isArray(prices)) {
    throw new Error('Both borders and prices must be arrays');
  }

  if (borders.length !== prices.length) {
    throw new Error('The length of borders and prices arrays must be the same');
  }

  if (borders.length === 0) {
    return [];
  }

  return borders.map((border, index) => ({
    cap: index === 0 ? border : border - (borders[index - 1] ?? 0),
    price: prices[index] ?? 0,
  }));
};

export { convertToTiers };
